const filterStateByTargets = (state = {}, modifiedTargets = new Map()) =>
  Object.entries(state).reduce((acc, [elementId, elementTargets]) => {
    const filteredTargets = Object.entries(elementTargets).reduce(
      (targetAcc, [target, breakpointBasedValue]) => {
        const filteredValue = Object.fromEntries(
          Object.entries(breakpointBasedValue).filter(([breakpointKey]) =>
            modifiedTargets.get(breakpointKey)?.has(target)
          )
        );

        return Object.keys(filteredValue).length > 0
          ? { ...targetAcc, [target]: filteredValue }
          : targetAcc;
      },
      {}
    );

    if (Object.keys(filteredTargets).length > 0) {
      return { ...acc, [elementId]: filteredTargets };
    }

    return acc;
  }, {});

export default filterStateByTargets;
